import React, { useState, useEffect } from 'react'
import tw, { styled } from 'twin.macro'

import { Column } from '@ui-kit/helpers'

import AlertSVG from './assets/alert.inline.svg'
import {X as CloseSVG } from 'react-feather'


const Notification = ({ nid, title, body, expires, useLocalStorage }) => {

    const [ mounted, setMounted ] = useState(false);

    const [ visible, setVisible ] = useLocalStorage(`nova-energy__notify-${nid}-${expires}`, true);

    useEffect(() => {
        setMounted(true);
    }, [])

    return visible && mounted && (
        <Style visible={visible} className={`notification ${visible ? 'opacity-100' : 'opacity-0'}`}>
            <Column>
                <span className="notification__icon"><AlertSVG /></span>
                <div className="notification__body">
                    <strong className="notification__title">{title}</strong>
                    <div dangerouslySetInnerHTML={{__html: body.html}} />
                </div>

                <button aria-label="Close notification" type="button" onClick={() => setVisible(false)}><CloseSVG /></button>
            </Column>
        </Style>
    )
}
export default Notification


const Style = styled.aside`
    background-color: var(--silver);
    position: relative;
    border-bottom: 1px rgba(0,0,0,.05) solid;
    height: auto;
    overflow: hidden;
    transition: margin-top .2s ease;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 499;
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    box-shadow: 0 0 2vh rgba(0,0,0,0.35);

    .site__column {
        display: flex;
        align-items: center;
        height: 100%;
    }

    .notification__icon {
        margin-right: 1.5em;

        svg {
            ${tw `animate-pulse`}
            animation-duration: 1s;
            max-width: 2.75em;
        }
    }

    .notification__title {
        ${tw `block`}
    }

    p {
        margin-bottom: 0;

        a {
            color: var(--textColor);
            ${tw `underline underline-offset-2 font-semibold hover:text-primary focus-visible:text-orange`}
        }
    }

    button {
        margin-left: auto;
        border: none;
        padding: 0;
        background-color: var(--light);
        display: block;
        width: 2.5em;
        height: 2.5em;
        min-width: 2.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        ${tw `appearance-none focus-visible:bg-orange hover:bg-primary rounded-full cursor-pointer`}
    }

`